import { useContext } from 'react'
import { LexiconContext } from '../contexts/Lexicon'
import defaultLexicon from '../lexicon/default'

export default () => {
  const context = useContext(LexiconContext)

  if (!context) {
    console.warn("Lexicon undefined - make sure your custom lexicon is configured correctly & the component is within the Lexicon Provider")
    return defaultLexicon
  }

  return context.lexicon
}
